import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Workspace } from '@robocorp/robocloud-internal-cds-sdk';
import { Box, SideNavigation } from '@robocorp/components';
import JoinWorkspaceButton from './JoinWorkspaceButton';

interface Props {
  workspaces?: Workspace[];
}

export const OtherWorkspacesAccordion: FC<Props> = ({ workspaces = [] }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      <SideNavigation.Accordion
        open={isOpen}
        title={t('otherWorkspaces')}
        onClick={() => setIsOpen((currentIsOpen) => !currentIsOpen)}
      >
        {workspaces.map((ws) => (
          <SideNavigation.ItemGroup key={ws.id}>
            <SideNavigation.Item as="span">{ws.name}</SideNavigation.Item>
            <JoinWorkspaceButton organizationId={ws.organization_id} workspaceId={ws.id} />
          </SideNavigation.ItemGroup>
        ))}
      </SideNavigation.Accordion>
    </Box>
  );
};
